﻿import React, { useContext, useEffect } from 'react';
import { BookingFlowContext } from '../BookingFlowContext'
import { shouldAccountBeUpdated } from '../../../../../Resources/Scripts/_Shared/helpers';
import { isSalesOrderAttachmentsEnabled } from '../util';

export const BackNavigation = ({ disabled = false }) => {
  const { bookingFlowContext, setBookingFlowContext } = useContext(BookingFlowContext);
  const backHandler = () => {
    const newActiveStep = ReturnPreviousStep(bookingFlowContext)
    setBookingFlowContext({ ...bookingFlowContext, activeStep: newActiveStep })
  };

  useEffect(() => {
    const initPopstateListener = (e) => {
      if (e.state && e.state?.activeStep !== null && e.state.activeStep < bookingFlowContext.activeStep)
        backHandler();
    }

    window.addEventListener('popstate', initPopstateListener);
    return () => { window.removeEventListener('popstate', initPopstateListener); }
  }, [bookingFlowContext.availableSteps.onlineBooking.order])

const clickHandler = () => {
  const activeStep = ReturnPreviousStep(bookingFlowContext);
  setBookingFlowContext({ ...bookingFlowContext, activeStep });
  if (!bookingFlowContext.episerver.hasWebticketAccount && activeStep === bookingFlowContext.availableSteps.onlineBooking.index) location.reload(); 
}

  return (
    <button className="bookingflowpage__back" disabled={disabled} onClick={clickHandler}>{bookingFlowContext.localization.global.buttons.previousStep}</button>
  )
}

export const isSkidataPermit = (bookingFlowContext) =>
  bookingFlowContext?.availableSteps?.onlineBooking?.formData?.productSelection?.item?.PermitUsageType?.toLowerCase() === "skidata";

/**
 * Returns the step index that should follow the vehicle stage (AddVehicle, or
 * the SKIDATA short-circuit which skips AddVehicle). Returns DocumentUpload if
 * the PMC has sales-order attachments enabled, otherwise OrderOverview.
 */
export const ReturnStepAfterVehicleStage = (bookingFlowContext) =>
  isSalesOrderAttachmentsEnabled(bookingFlowContext)
    ? bookingFlowContext.availableSteps.documentUpload.index
    : bookingFlowContext.availableSteps.orderOverview.index;

export const ReturnPreviousStep = (bookingFlowContext) => {
  if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.login.index) {
    //Login selection
    return bookingFlowContext.availableSteps.onlineBooking.index;
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.createAccount.index) {
    //Create account
       return bookingFlowContext.availableSteps.onlineBooking.index;
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.addVehicle.index) {
    //Add vehicle
      return bookingFlowContext.availableSteps.onlineBooking.index;
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.documentUpload.index) {
    //Document upload — back to addVehicle (or onlineBooking for SKIDATA where addVehicle is skipped)
    return isSkidataPermit(bookingFlowContext)
      ? bookingFlowContext.availableSteps.onlineBooking.index
      : bookingFlowContext.availableSteps.addVehicle.index;
  }
  else if (bookingFlowContext.activeStep === bookingFlowContext.availableSteps.orderOverview.index) {
    //Order overview — back to DocumentUpload if attachments are enabled,
    //otherwise jump back over it to the vehicle stage (or onlineBooking for SKIDATA).
    if (isSalesOrderAttachmentsEnabled(bookingFlowContext)) {
      return bookingFlowContext.availableSteps.documentUpload.index;
    }
    return isSkidataPermit(bookingFlowContext)
      ? bookingFlowContext.availableSteps.onlineBooking.index
      : bookingFlowContext.availableSteps.addVehicle.index;
  }
}
